import { atom } from "jotai";

import { SUPPORTED_LOCALES, type SupportedLocale } from "../types";
import { PREFERENCE_DEFAULTS, appAtom } from "./app";

const defaultLocale = "en";

const rawLocale = document.documentElement.dataset.locale ?? defaultLocale;

const lang = rawLocale.split("_")[0] as SupportedLocale;

export const initialLocale: SupportedLocale = SUPPORTED_LOCALES.includes(lang)
  ? lang
  : defaultLocale;

export const localeAtom = atom<SupportedLocale>(initialLocale);

export const documentLocale = rawLocale.replace("_", "-");

export const SYSTEM_TIME_ZONE = "system";

export const getSystemTimeZone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export const timeZoneAtom = atom(
  // Storage written before a preference existed has no value for it yet.
  (get) => get(appAtom).timeZone ?? PREFERENCE_DEFAULTS.timeZone,
  (_get, set, newTimeZone: string) => {
    set(appAtom, (prev) => ({ ...prev, timeZone: newTimeZone }));
  },
);

export const resolvedTimeZoneAtom = atom((get) => {
  const timeZone = get(timeZoneAtom);

  return timeZone === SYSTEM_TIME_ZONE ? getSystemTimeZone() : timeZone;
});
